// // useIPAddress.js
// import { useEffect, useState } from "react";
// import { baseapi } from "../Environmentalurl";

// const useIPAddress = () => {
//   const [ip, setIP] = useState("");

//   useEffect(() => {
//     fetch( `${baseapi}/clientip`, {
//       method: "GET",
//       credentials: "include",
//       headers: {
//         "Content-Type": "text/plain",
//       },
//     })
//       .then((res) => {
//         if (!res.ok) {
//           throw new Error("Failed to fetch IP");
//         }
//         return res.text();
//       })
//       .then((data) => {
//         setIP(data);
//       })
//       .catch((err) => {
//         console.error("IP fetch error:", err);
//         setIP("UNKNOWN");
//       });
//   }, []);

//   return ip;
// };

// export default useIPAddress;

// useIPAddress.js
// import { useState, useEffect } from "react";

// const getDeviceId = () => {
//   let deviceId = localStorage.getItem("deviceId");

//   if (!deviceId) {
//     deviceId = crypto.randomUUID();
//     localStorage.setItem("deviceId", deviceId);
//   }

//   return deviceId;
// };

// export default getDeviceId;


const getDeviceId = () => {
  return "b3c8d684-0b76-4858-afd3-d4a6d977724f";
};

export default getDeviceId;

